<template>
  <div class="insurance-wrapper">
    <!-- 合同基本信息 -->
    <TableToolTemp :toolListProps="basicInfo" />
    <Table :data="tableData" :options="listDataOptions" style="margin-bottom: 20px;" align=center></Table>

    <!-- 保单信息 -->
    <TableToolTemp :toolListProps="{
        toolTitle: '保单信息',
      }"></TableToolTemp>
    <el-card class="box-card">
      <template>
        <ul class="formDetails">
          <li>保单号：{{ policyInfo.policyCode }}</li>
          <li>保险公司：{{ policyInfo.insuranceCompanyName }}</li>
          <li>出单日期：{{ policyInfo.signTime | momentTime('yyyy-MM-dd') }}</li>
          <!-- <li>保费结算类型：{{ policyInfo.settlementType | getDicItemName('gcbs.premium.settlement.type') }}</li> -->
          <li>生效日期：{{ policyInfo.effectiveTime | momentTime('yyyy-MM-dd') }}</li>
          <li>有效期至：{{ policyInfo.validityTime | momentTime('yyyy-MM-dd') }}</li>
          <!-- <li>业务类型：{{ policyInfo.businessType | getDicItemName('gcbs.business.nature') }}</li> -->
          <!-- <li>是否可续保：{{ policyInfo.isRenew | getDicItemName('gcbs.renew.insurance') }}</li> -->
          <!-- <li>来源性质：{{ policyInfo.channelType | getDicItemName('gcbs.channel.type') }}</li> -->
          <li>总保费：{{ policyInfo.totalPremium }}元</li>
          <li>被保总人数：{{ policyInfo.insuredNums }}人</li>
          <!-- <li>佣金率：{{ policyInfo.commissionRates }}</li> -->
          <!-- <li>手续费率：{{ policyInfo.brokerageRates }}</li> -->
        </ul>
      </template>
    </el-card>

    <!-- 销售人员信息 -->
    <!-- <TableToolTemp :toolListProps="{
        toolTitle: '销售人员信息',
      }"></TableToolTemp> -->
    <!-- <el-card class="box-card"> -->
      <!-- <template> -->
        <!-- <ul class="formDetails"> -->
          <!-- <li>销售人员编码：{{ agentInfo.agentCode }}</li> -->
          <!-- <li>出单机构：{{ agentInfo.orgName }}</li> -->
          <!-- <li>销售人员姓名：{{ agentInfo.agentName }}</li> -->
          <!-- <li>所属团队：{{ agentInfo.groupName }}</li> -->
        <!-- </ul> -->
      <!-- </template> -->
    <!-- </el-card> -->

    <!-- 客户信息 -->
    <TableToolTemp :toolListProps="{
        toolTitle: '客户信息(投保人信息)',
      }"></TableToolTemp>
    <el-card class="box-card">
      <template>
        <ul class="formDetails">
          <li>企业名称：{{ customerInfo.customerEnterpriseName }}</li>
          <li>证件类型：{{ customerInfo.customerCardType | getDicItemName('gcbs.enterprise.certificate') }}</li>
          <li>证件号码：{{ customerInfo.customerCardNo }}</li>
          <li>
            所在地：
            <template v-if="customerInfo.provinceCode">{{ customerInfo.provinceCode }}</template>
            <template v-if="customerInfo.cityCode">- {{ customerInfo.cityCode }}</template>
            <template v-if="customerInfo.areaCode">- {{ customerInfo.areaCode }}</template>
          </li>
          <li>详细地址：{{ customerInfo.address }}</li>
          <li>联系人：{{ customerInfo.contactsName }}</li>
          <li>手机号：{{ customerInfo.contactsPhone }}</li>
          <li>邮箱：{{ customerInfo.contactsEmail }}</li>
          <!-- <li>证件类型：{{ customerInfo.contactsCardType | getDicItemName('gen.identityType') }}</li>
          <li>证件号码：{{ customerInfo.contactsCardNo }}</li> -->
          <!--<li v-if="hasType">
            企业证件照片：
            <el-button type="text" @click="popupImgShow = true">查看</el-button>
          </li>-->
        </ul>
      </template>
    </el-card>
    <!-- 被保人清单 -->
    <TableToolTemp :toolListProps="{
        toolTitle: '被保人清单',
      }"></TableToolTemp>
    <DtTable :data="insuredList" :options="insuredOptions">
      <el-table-column slot="index" label="序号" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column slot="operate" min-width="200" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="policyInsuredExist === '0'"
            @click="watchList(scope.row)"
          >查看人员清单</el-button>
          <el-button type="text" @click="watchType(scope.row)">查看险种责任</el-button>
        </template>
      </el-table-column>
    </DtTable>
    <!-- 影像件列表 -->
    <TableToolTemp :toolListProps="{
        toolTitle: '影像件列表',
      }"></TableToolTemp>
    <DtTable :data="fileList" :options="fileOptions">
      <el-table-column slot="index" label="序号" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column slot="operate" min-width="90" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text">
            <a :href="scope.row.filePath" target="_blank" :download="scope.row.fileName">查看</a>
          </el-button>
        </template>
      </el-table-column>
    </DtTable>

    <!-- 合同被保险人 -->
    <TableToolTemp :toolListProps="insured" />
    <el-button
      :disabled="!(insuredtableData&&insuredtableData.length>0)"
      type="primary"
      style="margin:0px 0px 10px 0px;"
      @click="exportData"
    >导出数据</el-button>
    <TableTree :data="insuredtableData" :options="insuredlistDataOptions" :source="'api-hr'">
    </TableTree>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pageData="initParam"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
    ></Pagination>
    <!-- 查看险种责任 -->
    <DtPopup
      :isShow.sync="popupTypeShow"
      title="查看险种责任"
      width="1100px"
      @close="popupTypeShow = false"
      :footer="false"
    >
      <PopupType :isShow.sync="popupTypeShow" :tempObj="tempObj" />
      <div style="font-size: 18px;margin-bottom: 25px;color: #999;">备注：以上展示内容均为本平台对上述产品理解，仅供参考，具体责任及其他情况以条款和保险公司解释为准</div>
    </DtPopup>
    <!-- 查看计划被保人清单 -->
    <DtPopup
      :isShow.sync="planInsuredShow"
      title="查看人员清单"
      width="1100px"
      @close="planInsuredShow = false"
      :footer="false"
    >
      <PlanInsured
        :isShow.sync="planInsuredShow"
        :tempList="tempList"
        :policyStatus="policyStatus"
      />
    </DtPopup>
  </div>
</template>
<script>
import PlanInsured from './planInsured';
import DtPopup from '@/components/layouts/DtPopup';
import PopupType from './popupType';
import { policyDetail, insuredExport} from '@/api/insuranceContract';
import TableToolTemp from '@/components/layouts/TableToolTemp';
import Table from '@/components/layouts/table';
import TableTree from '@/components/layouts/TableTree';
import Pagination from '@/components/layouts/Pagination';
import { myMixin } from '@/mixins';
import { create } from 'lodash';
import DtTable from '@/components/layouts/DtTable';
export default {
  mixins: [myMixin],
  components: {
    TableToolTemp,
    Table,
    TableTree,
    Pagination,
    DtTable,
    DtPopup,
    PopupType,
    PlanInsured,
  },
  data: () => {
    return {
      abc: true,
      dicArr: [
        'gcbs.premium.settlement.type',
        'gcbs.business.nature',
        'gcbs.renew.insurance',
        'gcbs.enterprise.certificate',
        'gcbs.channel.type',
        'gen.identityType',
        'insuredStatus',
        'gcbs.rela.with.staff'
      ],
      basicInfo: {
        toolTitle: '合同基本信息',
      },
      insured: {
        toolTitle: '合同被保险人',
      },
      tableData: [],
      listDataOptions: [
        { prop: 'enterpriseId', label: '机构编码',WelfareFlag:true, width: 200 },
        { prop: 'enterpriseName', label: '机构名称', width: '200' },
        { prop: 'policyName', label: '合同名称', width: '200px' },
        { prop: 'policyCode', label: '合同编号',width: 120 },
        { prop: 'productName', label: '保险公司' },
        { prop: 'effectiveTime', label: '起始日期' },
        { prop: 'validityTime', label: '结束日期' },
        { prop: 'totalInsured', label: '主被保险人数' },
        { prop: 'effectiveInsured', label: '在保主被保险人数' },
        { prop: 'contractualPremium', label: '契约保费(元)' },
      ],
      insuredtableData: [],
      insuredlistDataOptions: [
        { prop: 'policyCode', label: '合同编号' },
        { prop: 'policyName', label: '合同名称' },
        { prop: 'insuredName', label: '被保险人姓名' },
        { prop: 'insuredCardType', label: '被保险人证件类型', dic: 'gen.identityType' },
        { prop: 'insuredCardCode', label: '被保险人证件号码' },
        { prop: 'effectiveTime', label: '生效起期' },
        { prop: 'invalidTime', label: '生效止期' },
        { prop: 'status', label: '生效状态', dic: 'insuredStatus'},
        { prop: 'relaWithStaff', label: '与主被保人关系', dic: 'gcbs.rela.with.staff'},
        { prop: 'planPremium', label: '计划保费(元/人)' },
      ],
      insuredList: [],
      insuredOptions: [
        { prop: 'planName', label: '计划名称' },
        { prop: 'planPremium', label: '保费(元/人)' },
        { prop: 'insuredNum', label: '人数' },
      ],
      fileList: [],
      fileOptions: [
        { prop: 'type', label: '影像类型' },
        { prop: 'fileName', label: '文件名称' },
      ],
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: {
          policyId: '1',
        },
      },
      total: 0,
      policyInfo: {},
      agentInfo: {},
      customerInfo: {},
      popupTypeShow: false,
      planInsuredShow: false,
      tempObj: {},
      tempList: {},
      policyStatus: '',
      policyInsuredExist: '',
    };
  },
  methods: {
    init() {
      this.$store.commit('mapDicData', {
        dicCode: 'insuredStatus',
        dicItems: [
          { dicItemCode: '0', dicItemName: '未生效' },
          { dicItemCode: '2', dicItemName: '已生效' },
          { dicItemCode: '3', dicItemName: '已失效' },
        ],
      });
      this.queryData();
      this.policyStatus = this.$route.query.policyStatus;
    },
    async queryData(bool = true) {
      let enterprisePolicyApiVo = this.$route.query;
      let policyId = this.$route.query.policyId;
      this.initParam.param.policyId = policyId;
      policyDetail({
        enterprisePolicyApiVo,
        policyInsuredPage: this.initParam,
      }).then(res => {
        if (res.enterprisePolicy) {
          res.enterprisePolicy.contractualPremium = '￥' + this.turnToK(res.enterprisePolicy.contractualPremium);
          this.tableData = [res.enterprisePolicy];
          this.insuredtableData = res.insuredPage && res.insuredPage.list ?  res.insuredPage.list :[];
          this.total = res.insuredPage && res.insuredPage.total;
          this.policyInfo = res.policyDetail.policy;
          this.customerInfo = res.policyDetail.customer;
          this.agentInfo = res.policyDetail.agent;

          //司外保单仅展示保单影像、其他影像不展示
          if (this.policyInfo.policyType == '02') {
            this.fileList = [res.policyDetail.policyFile.find(item => item.type === '保单影像')];
          } else {
            this.fileList = res.policyDetail.policyFile.filter(item => item.fileName);
          }
          // 客户告知书,  经纪委托协议书
           this.fileList= this.fileList.filter(item=>{
  
             return item.type!='客户告知书'&&item.type!='经纪委托协议书'
           })
          this.insuredList =res.policyDetail.policyPlans? res.policyDetail.policyPlans:[];
          this.policyInsuredExist = res.policyDetail.policy.policyInsuredExist;
        }
      });
    },
    exportData() {
      let policyId = this.$route.query.policyId;
      insuredExport({ policyId });
    },
    turnToK(value) {
      return String(value).replace(/\B(?=(\d{3})+$)/g, ',');
    },
    // 查看险种责任
    watchType(obj) {
      // this.$store.commit('setQueryInfo', {
      //   productObj: Object.assign(obj, { policyCode: this.policyInfo.policyCode }),
      // });
      Object.assign(this.tempObj, obj, { policyCode: this.policyInfo.policyCode });
      this.popupTypeShow = true;
    },
    // 查看被保人清单
    watchList(object) {
      Object.assign(this.tempList, object, { policyCode: this.policyInfo.policyCode });
      this.planInsuredShow = true;
    }, 
  },
 
};
</script>
<style lang="less" scoped>
/* --------------------- 
        from表单
--------------------- */
.formDetails {
  display: flex;
  flex-wrap: wrap;
  li {
    box-sizing: border-box;
    width: 25%;
    word-break: break-all;
    line-height: 40px;
  }
}

.insurance-wrapper {
  color: #55555a;
  .box-card {
    margin: 0px 0px 20px 0px;
    color: #55555a;
    font-weight: 400;
  }
}
</style>
